@use "../../styles/breakpoint.module.scss" as *;

.inner {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.media {
    grid-column: 1 / span 5;

    @media ($above-mobile) and ($below-tablet) {
        padding-right: var(--spacer-24);
    }
}

.content {
    grid-column: 7 / span 6;

    @media ($above-mobile) and ($below-tablet) {
        grid-column: 6 / span 7;
    }
}

.media,
.content {
    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.tabList {
    display: flex;
    align-items: flex-end;
}

.tab {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 50%;
    min-height: var(--spacer-48);
    padding-block: 16px;
    box-shadow: inset 0 -1px 0 0 var(--gray);
    cursor: pointer;
    font: var(--font-p-10-lg);
    text-align: center;
    transition:
        box-shadow 0.2s,
        color 0.2s;

    &[aria-selected="true"] {
        box-shadow: inset 0 -2px 0 0 var(--red);
    }

    &[data-hovered] {
        color: var(--red);
    }
}

.documentPanel {
    padding-top: var(--spacer-48);

    @media ($below-mobile) {
        padding-top: 32px;
    }
}

.umrp {
    font: var(--font-h-34);
}

.caption {
    font: var(--font-p-16);
    color: var(--medium-gray);

    @media ($below-mobile) {
        margin-bottom: var(--spacer-80);
        padding-top: var(--spacer-16);
        text-align: center;
    }
}

.carousel {
    composes: outline from "../../styles/composable/utility.module.css";
    position: relative;
    width: 100%;
    margin-bottom: var(--spacer-32);

    &[data-focus-visible] {
        outline-offset: -2px;
    }
}

.carouselTabList {
    position: absolute;
    width: var(--spacer-40);
    z-index: 1;

    @media ($above-mobile) {
        top: 0;
        left: 0;
        height: 100%;
        flex-direction: column;
        justify-content: flex-start;
        gap: 4px;
        translate: 0;
    }

    @media ($below-mobile) {
        bottom: 0;
        width: 100%;
        justify-content: center;
        gap: 0;
    }
}

.carouselTab {
    position: relative;
    background-color: transparent;

    &::before {
        content: "";
        position: absolute;
    }

    &:not([aria-selected]) {
        opacity: 1;
    }

    @media ($above-mobile) {
        width: var(--spacer-40);
        height: var(--spacer-40);
        border-radius: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        &[aria-selected]::before {
            box-shadow: inset 0 0 0 1px var(--red);
        }

        &::before {
            inset: 0;
        }
    }

    @media ($below-mobile) {
        width: 16px;
        height: 16px;

        img {
            display: none;
        }

        &::before {
            inset: 4px;
            border-radius: 4px;
            background-color: var(--color-contrast);
        }

        &:not([aria-selected]) {
            &::before {
                inset: 5px;
                opacity: 0.7;
            }
        }
    }
}

.carouselNav {
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: 50%;
    width: 100%;
    translate: 0 -50%;

    @media ($below-mobile) {
        display: none;
    }
}

.navArrow {
    display: none;
}

.wrapper {
    composes: outline from "../../styles/composable/utility.module.css";

    @media ($above-mobile) {
        width: calc(100% - (var(--spacer-64)));
        margin-left: var(--spacer-64);
    }

    &[data-focus-visible] {
        outline-offset: -2px;
    }
}

.carouselPanel {
    composes: outline from "../../styles/composable/utility.module.css";
    aspect-ratio: 1;
    overflow: hidden;
}

.picture {
    display: block;
    width: 100%;
    height: 100%;
}

.pictureSingleImage {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    margin-bottom: var(--spacer-24);
}

.image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.text {
    margin-bottom: var(--spacer-24);
    font: var(--font-p-16);
}
